module.exports = __webpack_public_path__ + "img/省钱省力.b01ce273.png";